import { Header } from "@/components/Header";
import { ProductionView } from "@/components/production/ProductionView";

export default function Haft() {
  return (
    <div className="min-h-screen relative z-10">
      <Header />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
        <div className="rise">
          <p className="font-mono text-xs text-amber-400 tracking-widest uppercase">Panel haftu</p>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight">Haft</h1>
        </div>
        <ProductionView base="/haft" canStatus={false} pdfBase="/haft" emptyText="Brak zamówień z haftem." />
      </main>
    </div>
  );
}
